import { render, staticRenderFns } from "./RequestRejected.vue?vue&type=template&id=2cf856fa"
import script from "./RequestRejected.vue?vue&type=script&lang=js"
export * from "./RequestRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports